import React, { FC } from 'react';
import { Box } from '@material-ui/core';
import {
  FullHeightContainer,
  StyledPage,
} from '../../app/components/DashboardLayout/DashboardLayout.style';
import { HeadsTableContainer } from '../containers/HeadsTableContainer/HeadsTableContainer';
import { PageHeader } from '../../app/components/DashboardLayout/PageHeader/PageHeader';

export const HeadView: FC = () => {
  return (
    <StyledPage title="Heads">
      <FullHeightContainer maxWidth={false}>
        <Box mb={3}>
          <PageHeader title="Heads" />
        </Box>
        <Box
          flexDirection="column"
          height="100%"
          justifyContent="center"
          flex={1}
        >
          <HeadsTableContainer />
        </Box>
      </FullHeightContainer>
    </StyledPage>
  );
};
